import { render, staticRenderFns } from "./OrganismProjectUI.vue?vue&type=template&id=72871c4e&"
import script from "./OrganismProjectUI.vue?vue&type=script&lang=js&"
export * from "./OrganismProjectUI.vue?vue&type=script&lang=js&"
import style0 from "./OrganismProjectUI.vue?vue&type=style&index=0&id=72871c4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectBuildingV2MoleculeExtraSidebarComponents: require('/app/components/molecules/project/buildingV2/MoleculeExtraSidebarComponents.vue').default,MoleculesProjectBuildingV2MoleculeExtraSidebarComponentsMobile: require('/app/components/molecules/project/buildingV2/MoleculeExtraSidebarComponentsMobile.vue').default,OrganismsProjectBuildingV2OrganismProjectAvailabilityOptions: require('/app/components/organisms/project/buildingV2/OrganismProjectAvailabilityOptions.vue').default,MoleculesProjectBuildingV2MoleculeFiltersPins3D: require('/app/components/molecules/project/buildingV2/MoleculeFiltersPins3D.vue').default,MoleculesProjectBuildingV2MoleculePinFocusPoint: require('/app/components/molecules/project/buildingV2/MoleculePinFocusPoint.vue').default})
